export default __webpack_public_path__ + "static/media/rarity-3.330288d7.png";